import { FormValueScope } from '@epages/react-components'
import Immutable from 'immutable'

import { useTranslate } from '../../utils/translate'
import FormGroup from '../formComponents/FormGroup'
import RadioButtonField from '../formComponents/RadioButtonField'
import TextareaField from '../formComponents/TextareaField'
import useHelpCenterLink from '../../utils/hooks/useHelpCenterLink'

export default function GoogleTagManagerSettings() {
  const t = useTranslate('interface')
  const scopedT = (key: string) => t(`components.bottomBar.storefrontSettings.googleTagManager.${key}`)
  const helpLink = useHelpCenterLink('GOOGLE_TAG_MANAGER')

  return (
    <FormValueScope name="googleTagManager">
      <>
        <div className="dali-settingslayer-element">
          {scopedT('description')}
          <br />
          <a className="ep-form-row-text-external-link" href={helpLink} target="_blank" rel="noopener noreferrer">
            {scopedT('descriptionLink')}
          </a>
        </div>
        <FormGroup label={scopedT('headInputField.label')} name="headHtml">
          <TextareaField />
        </FormGroup>
        <FormGroup label={scopedT('bodyInputField.label')} name="bodyHtml">
          <TextareaField />
        </FormGroup>
        <FormGroup label={scopedT('statusSection.title')} name="active" info={scopedT('statusSection.tooltip')}>
          <RadioButtonField
            buttons={[
              { label: scopedT('statusSection.onRadioButton.label'), value: true },
              { label: scopedT('statusSection.offRadioButton.label'), value: false },
            ]}
          />
        </FormGroup>
        <FormGroup label={scopedT('manageSection.title')} name="_not_used">
          <p className="ep-form-row-text">
            {scopedT('manageSection.description')}{' '}
            <a
              className="ep-form-row-text-external-link"
              href="https://tagmanager.google.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {scopedT('manageSection.descriptionLink')}
            </a>
          </p>
        </FormGroup>
      </>
    </FormValueScope>
  )
}

GoogleTagManagerSettings.displayName = 'GoogleTagManagerSettings'
GoogleTagManagerSettings.defaultValue = Immutable.fromJS({
  headHtml: '',
  bodyHtml: '',
  active: false,
})
